<template>
    <section>
        <div class="sp-title">应付</div>
        <div class="sp-nav"><span class="sp-nav-item">财务管理</span><span class="sp-nav-item-sple">/</span><span class="sp-nav-item">应付</span></div>


        <el-form :inline="true" :model="queryForm" class="query-form demo-form-inline">
            <el-form-item label="供应商名称:">
                <el-input v-model="queryForm.supplierName" placeholder="供应商名称"  clearable></el-input>
            </el-form-item>
            <el-form-item label="申请日期：">
              <el-date-picker
                style="width: 100%;"
                v-model="queryForm.applyTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          <el-form-item label="结算日期:">
            <el-date-picker
              style="width: 100%;"
              v-model="queryForm.settleTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
            <el-form-item>
                <el-button @click="onQuery" type="primary" >查询</el-button>
            </el-form-item>
        </el-form>
        <template>
            <el-table
                    class="el-table-info mytable"
                    :data="tableData"
                    stripe
                    style="width: 100%"
                    :show-overflow-tooltip="true"
                    border
                    :cell-class-name="rowClass"
                    >
                <el-table-column
                     prop="supplierName"
                     label="供应商名称"
                     width="220">
                </el-table-column>
                <el-table-column
                        prop="settleAmount"
                        label="结算金额"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="costType"
                        label="费用类型"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="applyTime"
                        label="申请日期"
                          width="140">
                </el-table-column>
                <el-table-column
                        prop="settleTime"
                        label="结算日期"
                        width="140">
                </el-table-column>
                <el-table-column
                     :formatter="(row, column, cellValue, index) => { return cellValue=='0'?'出纳打款中':'已结算'}"
                     prop="approvalStatus"
                     label="状态"
                     width="140">
                </el-table-column>
                <el-table-column
                        label="操作"
                >
                    <template slot-scope="scope">
                        <el-button @click="applyVerify(scope.row)" type="text" size="small">{{scope.row.approvalStatus == 0?'确认付款':'查看详情'}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    background
                    layout="prev, pager, next"
                    :total="total"
                    :page-size="pageSize"
                    :current-page="pageNo"
                    @current-change="eventPage"
                    style="text-align: right;padding: 10px 0px;background-color: #fff"
            >
            </el-pagination>
        </template>

      <work-flow-process-drawer  @refresh="refresh" @onCallback="handlerGlobalParams" ref="processDrawer1">
        <div slot="beforeFormSlot">
          <div style="display:flex;padding: 0 5px">
            <div style="width: 60%;">
              <div style="display:flex;margin-right: 40px;">
                <div class="info-title">收款金额：</div>
                <div class="info-val">{{info.supplierName}}</div>
              </div>
              <div style="display:flex;margin-right: 40px;">
                <div class="info-title">收款总金额：</div>
                <div class="info-val" style="margin-right: 5px;">{{info.settleAmount}}</div>
                <div class="info-title">元</div>
              </div>
            </div>
            <div style="width: 40%;">
              <div style="display:flex;">
                <div class="info-title">费用类型：</div>
                <div class="info-val">{{info.costType}}</div>
              </div>
              <el-button type="primary" size="mini">打印</el-button>
            </div>
          </div>
        <div>
          <el-table
            class="el-table-info mytable"
            :data="info.amountDetail"
            stripe
            style="width: 100%;margin-top: 30px;"
            id="out-table"
            :show-overflow-tooltip="true"
            :row-class-name="getRowClass"
          >
            <el-table-column type="expand">
              <template slot-scope="scope">
                <el-table class="el-table-info el-table-inner"
                          :data="scope.row.deductDetail"
                          size="medium"
                          style="width: 100%;margin: auto"
                >
                  <el-table-column
                    prop="voyageNumber"
                    label="航次号"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="costType"
                    label="费用类型"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="advanceAmount"
                    label="垫付金额"
                  >
                  </el-table-column>
                  <el-table-column
                    prop="deductAmount"
                    label="抵扣金额">
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column
              prop="voyageNumber"
              label="航次号"
            >
            </el-table-column>
            <el-table-column
              prop="costType"
              label="费用类型"
            >
            </el-table-column>
            <el-table-column
              prop="settleAmount"
              label="结算金额"
            >
            </el-table-column>
            <el-table-column
              prop="deductAmount"
              label="抵扣金额"
            >
            </el-table-column>
          </el-table>
        </div>
        </div>
      </work-flow-process-drawer>
    </section>
</template>

<script>

import {ERR_OK} from "../jslib/config";
import WorkFlowProcessDrawer from "../components/workflow/process";

export default {
    data() {
        return {
            queryForm:{},
            tableData: [
                {
                    supplierName:"秦皇岛力达",
                    settleAmount:350000,
                    costType:"运费",
                    applyTime:'2020/05/04',
                    settleTime:'2020/05/04',
                    approvalStatus:0,
                    amountDetail:[
                      {
                        voyageNumber:'2020060002',
                        costType:'运费',
                        settleAmount:1000000,
                        isDeduct:true,
                        deductAmount:5000,
                        deductDetail:[
                          {
                            voyageNumber:'2020060002',
                            costType:'港使费',
                            advanceAmount:4000,
                            deductAmount:5000,
                          }
                        ],
                      }
                    ],
                },
              {
                supplierName:"秦皇岛力达",
                settleAmount:350000,
                costType:"运费",
                applyTime:'2020/05/04',
                settleTime:'2020/05/04',
                approvalStatus:1,
                amountDetail:[
                  {
                    voyageNumber:'2020060002',
                    costType:'运费',
                    settleAmount:1000000,
                    isDeduct:false,
                    deductAmount:0,
                    deductDetail:[

                    ],
                  }
                ],
              },
            ],
            total:0,
            pageNo:1,
            pageSize:5,
            info:{},

        };
    },
    created() {

    },
    mounted() {
    },
    methods: {
      getRowClass({row, index}){
        return row.isDeduct ? '' : 'expand'
      },
        eventPage(e){

        },
        onQuery(){

        },
      refresh() {
        // 审批完成后会调用刷新方法
      },
      handlerGlobalParams(globalParams){
        // 这里是右侧划出审批页面并且请求完数据，返回的全局参数，参考 本组件 132～136 行代码
        console.log(globalParams);
      },
        applyVerify(item){
          // this.$refs.payapproval.openAddPanel(item);
          this.info = item

          this.$refs.processDrawer1.drawer = true
          this.$refs.processDrawer1.processId = '1284044773845401601' // 参考 本组件 142 行代码
          this.$refs.processDrawer1.title = 'xxx提交的审批'
          this.$refs.processDrawer1.doInit()
        },
        rowClass({row, column, rowIndex, columnIndex}){
            if(row.approvalStatus == 0 && columnIndex == 5 ){
                return 'warning-cell'
            } else if(row.approvalStatus == 1 && columnIndex == 5){
                return 'success-cell'
            } else if(row.approvalStatus == 0 && columnIndex == 6){
              return 'warning-btn'
            }
            return '';
        },
        saveSuccess(obj){
          this.$message({
            type: 'success',
            message: obj
          });
        },
    },
    computed: {},
    components: {WorkFlowProcessDrawer}
}
</script>

<style scoped>
    .query-form{
        text-align: left;
        padding-top: 10px;
    }
    .sp_add_left{
        width: 45%;
        margin-right: 5%;
    }
    .sp_add_right{
        width: 45%;
    }
    .el-table-info >>> .cell{
        text-align: center;
    }
    .el-table-info >>> th {
        background: #EDF5FF;
    }
    .mytable td  {
        padding-top: 0.5rem;
        padding-bottom: 0.5rem;
    }
    .mytable td .cell {
        padding-left: 0.1rem;
        padding-right: 0.1rem;
    }
    .el-table-info >>> .warning-cell{
        color: red;
    }
    .el-table-info >>> .success-cell{
        color: #6DD400;
    }
    .el-table-info >>> .warning-btn .el-button--text {
      color: #FA6400;
    }
    .el-table-info >>> .expand .el-table__expand-column .cell{
      display: none;
    }
    .info-title{
      line-height: 30px;
    }
    .info-val{
      line-height: 30px;
      color: #2cb7fd;
    }
</style>
